import information from '@/views/mainContentProvince/information'
import special from '@/views/mainContentProvince/information/special'
import cut from '@/views/mainContentProvince/information/cut'
import synthesize from '@/views/mainContentProvince/information/synthesize'
import enclosure from '@/views/mainContentProvince/information/enclosure'
import download from '@/views/mainContentProvince/information/download'
import basemenu from '@/views/mainContentProvince/information/base'

import addmuseumperson from '@/views/mainContentProvince/user/listNew'

import specialist from '@/views/mainContentProvince/specialist'

import addspecialist from '@/views/mainContentProvince/specialist/listNew'

import country from '@/views/mainContentProvince/country'
import addcountry from '@/views/mainContentProvince/country/listNew'
import province from '@/views/mainContentProvince/province'
import addprovince from '@/views/mainContentProvince/province/listNew'
import pftj from '@/views/mainContentProvince/statisticalQuery/pftj'
import museum from '@/views/mainContentProvince/statisticalQuery/museum'
import pfcx from '@/views/mainContentProvince/statisticalQuery/pfcx'
import progress from '@/views/mainContentProvince/processManagement'
import addaudit from '@/views/mainContentProvince/audit/addaudit'
import cutaudit from '@/views/mainContentProvince/audit/cutaudit'
import scoreadjust from '@/views/mainContentProvince/audit/scoreadjust'
import otherfile from '@/views/mainContentProvince/information/otherfile'
import ranking from '@/views/mainContentProvince/statisticalQuery/ranking'

import confirmProvince from '@/views/mainContentProvince/confirmProvince'
export default {
  path: '/informationDeclarationProvince',
  component: information,
  exact: true,
  children: [
    {
      path: '/informationDeclaration/museumbaseinfoProvince',
      component: basemenu,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/specialProvince',
      component: special,
      exact: true,
    },
    {
      path: '/informationDeclaration/enclosureProvince',
      component: enclosure,
      exact: true,
    },
    {
      path: '/informationDeclaration/downloadProvince',
      component: download,
      exact: true,
    },
    {
      path: '/expert/addmuseumpersonProvince',
      component: addmuseumperson,
      exact: true,
    },
    {
      path: '/expert/specialistProvince',
      component: specialist,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/warningProvince',
      component: cut,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/proposalProvince',
      component: synthesize,
      exact: true,
    },
    {
      path: '/expert/addspecialistProvince',
      component: addspecialist,
      exact: true,
    },
    {
      path: '/person/userProvince',
      component: country,
      exact: true,
    },
    {
      path: '/person/userProvince/addcountryProvince',
      component: addcountry,
      exact: true,
    },
    {
      path: '/informationDeclaration/provinceProvince',
      component: province,
      exact: true,
    },
    {
      path: '/informationDeclaration/addprovinceProvince',
      component: addprovince,
      exact: true,
    },
    {
      path: '/query/scoreProvince',
      component: pfcx,
      exact: true,
    },
    {
      path: '/informationDeclaration/progressProvince',
      component: progress,
      exact: true,
    },
    {
      path: '/confirm/addauditProvince',
      component: addaudit,
      exact: true,
    },
    {
      path: '/confirm/cutauditProvince',
      component: cutaudit,
      exact: true,
    },
    {
      path: '/confirm/scoreadjustProvince',
      component: scoreadjust,
      exact: true,
    },
    {
      path: '/informationDeclaration/addition/otherfileProvince',
      component: otherfile,
      exact: true,
    },
    {
      path: '/confirmProvince',
      component: confirmProvince,
      exact: true,
    },
  ]
}
